import script from "./MainMenuHorizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenuHorizontal.vue?vue&type=script&setup=true&lang=js"

import "./MainMenuHorizontal.vue?vue&type=style&index=0&id=7bfab9c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bfab9c3"]])

export default __exports__